module.exports = __webpack_public_path__ + "static/img/keyan.e20ea7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyan.png
// module id = vek4
// module chunks = 2